import { openSplitViewState } from '@approvalmax/ui/src/components';
import { useAtomValue, useSetAtom } from 'jotai';
import { useEffect } from 'react';
import { usePrevious } from 'react-use';

import { ContentSplitViewMode, contentSplitViewState } from '../states';

export const useClearSplitViewContentOnClose = () => {
    const setContentSplitView = useSetAtom(contentSplitViewState);
    const openSplitView = useAtomValue(openSplitViewState);
    const prevOpenSplitView = usePrevious(openSplitView);

    useEffect(() => {
        if (prevOpenSplitView && !openSplitView) {
            setContentSplitView({ mode: ContentSplitViewMode.Empty });
        }
    }, [openSplitView, prevOpenSplitView, setContentSplitView]);
};
